export type PropsType = {
  dataSrc?: any;
  deleteRow?: any;
  attachments?: any;
  editRow?: any;
  setAddModal?: boolean;
  addResource?: boolean;
  isFileCompatible?: boolean;
  disableTable?: boolean;
  disableLimit?: boolean;
};

export const compatibleTypes = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'application/pdf',
  'application/zip',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
  'text/markdown',
  'text/plain',
  'application/json',
  'video/mp4',
];
